import { cn } from "@/lib/cn";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: number | string;
  width?: number | string;
  circle?: boolean;
  visible?: boolean;
}

/** Reemplazo de `<Skeleton>` de Mantine · placeholder animado (pulse) mientras carga. */
export function Skeleton({
  height,
  width,
  circle,
  visible = true,
  className,
  style,
  children,
  ...props
}: SkeletonProps) {
  if (!visible) return <>{children}</>;
  return (
    <div
      className={cn("animate-pulse bg-muted", circle ? "rounded-full" : "rounded-md", className)}
      style={{ height, width, ...style }}
      {...props}
    />
  );
}
